import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Optimizes Auxo CDN image URLs using Cloudflare on-the-fly resizing.
 */
export function optimizeImageUrl(url, width = 800, quality = 85) {
  if (!url || typeof url !== "string") return url;
  if (url.includes("/cdn-cgi/image/")) return url;
  if (url.startsWith("https://assets.auxodev.dk/")) {
    const path = url.replace("https://assets.auxodev.dk/", "");
    return `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/${path}`;
  }
  return url;
}
